import { render, staticRenderFns } from "./userProjectIndex.vue?vue&type=template&id=3ddef871&scoped=true"
import script from "./userProjectIndex.vue?vue&type=script&lang=js"
export * from "./userProjectIndex.vue?vue&type=script&lang=js"
import style0 from "./userProjectIndex.vue?vue&type=style&index=0&id=3ddef871&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddef871",
  null
  
)

export default component.exports